<template>
  <div class="app-footer">
    <p>{{ timeString }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, ref } from 'vue'
import moment from 'moment'

export default defineComponent({
  name: 'AppFooter',
  setup() {
    const date = ref(moment().utc())
    const timeString = computed(() => {
      return `Server Time ${date.value.format('HH:mm:ss | MMMM D, YYYY')}`
    })
    onMounted(() => {
      setInterval(() => {
        date.value = moment().utc()
      }, 1000)
    })

    return {
      timeString
    }
  }
})
</script>

<style lang="scss" scoped>
.app-footer {
  height: 30px;
  width: 100%;
  text-align: center;
  background-color: var(--el-border-color-light);
  vertical-align: middle;
  line-height: 1.5;
  position: fixed;
  z-index: 2000;
  bottom: 0;
  font-size: 10px;
}
</style>
